<div class="reset-password" fxLayout="column">
	<div fxLayout="row" class="full-height" fxLayoutAlign="center center ">
		<mat-card class="padding-25 mat-elevation-z5" fxFlex="500px"  fxFlex.sm="80%" fxFlex.lt-sm="90%" >
		<form [formGroup]="resetPasswordForm"  fxLayout="column" (ngSubmit)="resetPasswordForm.valid && onSubmit(resetPasswordForm.value)"
		autocomplete="off" autocorrect="off" fxLayoutGap="25px"  novalidate>

			<div class="title">
				<h2 escCustomId="title" class="mat-primary-color">{{ 'TITLE_RESET_PASSWORD' | translate }}</h2>
				<h4 escCustomId="title_app_name">{{ 'PROJECT_NAME' | translate }}</h4>
			</div>

			<mat-label escCustomId="form_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
					{{errorMessage}}
			</mat-label>

			<div escCustomId="hint" class="text-center mat-caption mat-warn-color">{{ 'HINT_REQUIRED' | translate }}</div>

			<mat-form-field>
				<input escCustomId="email" 
					matInput 
					[placeholder]="'LABEL_EMAIL_ADDRESS' | translate"
					formControlName="email" 
					autocomplete="off"
					required>
				<mat-error escCustomId="email_required_error" *ngIf="resetPasswordForm.controls['email'].hasError('required')">
					{{ 'FORM_ERROR_EMAIL_REQUIRED' | translate }}
				</mat-error>
				<mat-error escCustomId="email_invalid_error" *ngIf="resetPasswordForm.controls['email'].hasError('whitespace')">
					{{ 'FORM_ERROR_VALID_EMAIL' | translate }}
				</mat-error>
				<mat-error escCustomId="email_invalid_error" *ngIf="resetPasswordForm.controls['email'].hasError('email')">
					{{ 'FORM_ERROR_VALID_EMAIL' | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field>
				<input escCustomId="code" 
					matInput 
					[placeholder]="'LABEL_VERIFICATION_CODE' | translate"
					formControlName="code" 
					autocomplete="off"
					required>
					<button fxFlex matSuffix mat-button 
					id="id_reset_password_btn_resend_verification_code"
					[disabled]="resetPasswordForm.controls['email'].invalid"
					(click)="resendVerificationCode(resetPasswordForm.value)"
					type="button"
					color="primary" 
					>
					{{ (isResendingCode ? 'RESENDING' : 'RESEND') | translate }}
				  </button>
				<mat-error escCustomId="code_required_error" *ngIf="resetPasswordForm.controls['code'].hasError('required')">
					{{ 'MESSAGE_ERROR_VERIFICATION_CODE_REQUIRED' | translate }}
				  </mat-error>
				  <mat-error escCustomId="code_incorrect_error" *ngIf="resetPasswordForm.controls['code'].hasError('codeMismatch')">
					{{ 'MESSAGE_ERROR_VERIFICATION_CODE_INCORRECT' | translate }}
				  </mat-error>
				  <mat-error escCustomId="code_invalid_error" *ngIf="resetPasswordForm.controls['code'].hasError('whitespace')">
					{{ 'MESSAGE_ERROR_INVALID_CODE' | translate }}
				  </mat-error>
			</mat-form-field>

			<mat-form-field>
				<input matInput 
					escCustomId="password"
					[placeholder]="'LABEL_NEW_PASSWORD'| translate" 
					minlength="8" 
					maxlength="60" 
					[type]="show.password ? 'text' : 'password'"
					formControlName="password">
				<mat-icon *ngIf="resetPasswordForm.controls['password'].value" 
					escCustomId="password"
					matSuffix 
					(click)="show.password = !show.password"
					[svgIcon]="show.password ? 'eye-off' : 'eye'">
				</mat-icon>
	
				<mat-error escCustomId="password_required_error" *ngIf="resetPasswordForm.controls['password'].hasError('required')">
					{{ 'MESSAGE_ERROR_PASSWORD_REQUIRED' | translate }}
				</mat-error>
				<mat-error escCustomId="password_min_error" *ngIf="resetPasswordForm.controls['password'].hasError('minlength')">
					{{ 'MESSAGE_ERROR_PASSWORD_MIN_LENGTH' | translate }}
				</mat-error>
				<mat-error escCustomId="password_max_error" *ngIf="resetPasswordForm.controls['password'].hasError('maxlength')">
					{{ 'MESSAGE_ERROR_PASSWORD_MAX_LENGTH' | translate }}
				</mat-error>
				<mat-error escCustomId="password_pattern_error" *ngIf="resetPasswordForm.controls['password'].hasError('pattern')">
					{{ 'MESSAGE_ERROR_PASSWORD_PATTERN' | translate }}
				</mat-error>
				<mat-error escCustomId="password_invalid_error" *ngIf="resetPasswordForm.controls['password'].hasError('invalidPassword')">
					{{ 'MESSAGE_ERROR_INVALID_PASSWORD' | translate }}
				</mat-error>
				<mat-error escCustomId="password_same_error" *ngIf="resetPasswordForm.controls['password'].hasError('matchPassword')">
					{{ 'MESSAGE_ERROR_SAME_LAST_PASSWORD' | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field>
				<input matInput 
					escCustomId="confirm_password"
					[placeholder]="'LABEL_CONFIRM_NEW_PASSWORD' | translate" 
					[type]="show.confirm ? 'text' : 'password'"
					formControlName="confirmPassword">
				<mat-icon 
					escCustomId="confirm_password"
					*ngIf="resetPasswordForm.controls['confirmPassword'].value" 
					matSuffix 
					(click)="show.confirm = !show.confirm"
					[svgIcon]="show.confirm ? 'eye-off' : 'eye'">
				</mat-icon>
				<mat-error escCustomId="confirm_password_required_error" *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('required')">
					{{ 'MESSAGE_ERROR_PASSWORD_REQUIRED' | translate }}
				</mat-error>
				<mat-error escCustomId="confirm_password_incorrect_error" *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('matchPassword')">
					{{ 'MESSAGE_ERROR_INCORRECT_CONFIRM_PASSWORD' | translate}}
				</mat-error>
			</mat-form-field>

			<button escCustomId="submit" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
				{{ (isSubmitting ? 'SUBMITTING' : 'SUBMIT') | translate }}
			</button>

			<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
				<button fxFlex mat-button 
				  id="id_reset_password_back"
				  type="button"
				  routerLink="../login" 
				  [queryParams]="resetPasswordForm.controls['email'].valid ? { email: resetPasswordForm.controls['email'].value } : {}"
				  color="primary">
				  {{ 'RETURN_TO_LOGIN' | translate }}
				</button>
			  </div>

		</form>
	</mat-card>
	</div>
	<esc-footer></esc-footer>
</div>